
import React from 'react';
import '../styles/logo-scroller.css';

const LogoScroller = () => {
  const logos = [{
    src: "/lovable-uploads/3468fa0f-e323-40de-9551-00dc45e92000.png",
    alt: "Boundless Logo",
    width: 120,
    height: 50
  }, {
    src: "/lovable-uploads/38cfdc1e-cba7-41cb-bcbd-71f5a1f6fdbc.png",
    alt: "Apis Logo",
    width: 120,
    height: 10
  }, {
    src: "/lovable-uploads/d7ae03a5-0634-4a56-aa17-2eb398812fae.png",
    alt: "Everest Effect Logo",
    width: 120,
    height: 50
  }, {
    src: "/lovable-uploads/5678991c-7c37-41e8-929d-729fb4a048aa.png",
    alt: "Merity Logo",
    width: 120,
    height: 50
  }, {
    src: "/lovable-uploads/4a7fac27-bea5-421d-8dfe-89e0054af609.png",
    alt: "Orka Logo",
    width: 120,
    height: 50
  }, {
    src: "/lovable-uploads/e96f3ed2-671a-4b21-9a92-da4df1c098b4.png",
    alt: "Ondeck Logo",
    width: 120,
    height: 60
  }, {
    src: "/lovable-uploads/ea01b06a-9af7-43fb-89cc-c850a35dec0e.png",
    alt: "Citi Logo",
    width: 120,
    height: 50
  }, {
    src: "/lovable-uploads/9bed48fd-13c3-4405-9987-729a25fe0856.png",
    alt: "CA Logo",
    width: 120,
    height: 50
  }];

  return <div className="logo-scroller-container w-full overflow-hidden relative py-4 h-16 sm:h-20 md:h-24 bg-cyan-50/30 rounded-xl shadow-soft">
      {/* Gradient fade effect on edges */}
      <div className="absolute left-0 top-0 h-full w-8 md:w-16 z-10 bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
      <div className="absolute right-0 top-0 h-full w-8 md:w-16 z-10 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
      
      <div className="logo-scroller flex items-center">
        {/* First set of logos */}
        <div className="logo-row flex">
          {logos.map((logo, index) => <div key={`logo-1-${index}`} className="logo-item flex items-center justify-center sm:mx-1 md:mx-2 transition-all duration-300 px-0 mx-[10px]">
              <img src={logo.src} alt={logo.alt} loading="lazy" width={logo.width} height={logo.height} className={logo.alt === "Apis Logo" ? "h-2 sm:h-3 md:h-4 lg:h-5 object-contain" : 
                           logo.alt === "Ondeck Logo" ? "h-4 sm:h-5 md:h-6 lg:h-7 object-contain" : 
                           "h-3 sm:h-4 md:h-5 lg:h-6 object-contain"} />
            </div>)}
        </div>
        
        {/* Duplicate set for seamless scrolling */}
        <div className="logo-row flex">
          {logos.map((logo, index) => <div key={`logo-2-${index}`} className="logo-item flex items-center justify-center mx-1 sm:mx-1 md:mx-2 transition-all duration-300 px-[10px]">
              <img src={logo.src} alt={logo.alt} loading="lazy" width={logo.width} height={logo.height} className={logo.alt === "Apis Logo" ? "h-2 sm:h-3 md:h-4 lg:h-5 object-contain" : 
                           logo.alt === "Ondeck Logo" ? "h-4 sm:h-5 md:h-6 lg:h-7 object-contain" : 
                           "h-3 sm:h-4 md:h-5 lg:h-6 object-contain"} />
            </div>)}
        </div>
      </div>
    </div>;
};

export default LogoScroller;
